<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import wx from 'weixin-js-sdk'
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';

	import stringUtils from "../assets/js/stringUtil.js";

    import { getTemplateInfo,submitProcess,AllowApplyForVerify } from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'


	import {
		formatDate
	} from '@/utils/date'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				flowId:null,
				listLoading: false,
				isDisabled: false,
				formLoading:false
			}
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation();
			stringUtils.setAddIsShow(false);
		},
		methods: { //方法
			
			getTemplate:async function() {
				var title = this.logInfo.fullName;
				var departs=title.split("/");
				
				var jobLevel = this.logInfo.JobLevel;
				// if(departs.indexOf("房友圈")>-1||departs.indexOf("代理")>-1){
				// 	if(title.indexOf("非营业")>-1){
				// 		this.Message({
				// 			message: '没有申请权限',
				// 			type: 'error',
				// 			duration: 1000
				// 		});
				// 		this.isDisabled = true;
				// 	}
				// }
			 //     if (departs.indexOf("住宅部") == -1 &&
				// 	departs.indexOf("房友圈") == -1 &&
				// 	departs.indexOf("工商铺商业运营中心") == -1 &&
				// 	departs.indexOf("二级市场营运中心") == -1 &&
				// 	departs.indexOf("代理") == -1&&
				// 	this.isDisabled == false
				// ) {
				// 	this.Message({
				// 		message: '没有申请权限',
				// 		type: 'error',
				// 		duration: 1000
				// 	});
				// 	this.isDisabled = true;
				// }
				this.listLoading = true;
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					
					controls.TemplateContent.Controls.forEach(async (item) => {
						if (item.Property.Title[0].Text == "流程条件") {
							item.Value = 0;
							if (title.indexOf("住宅部") > -1) {
								if(title.indexOf("东南区")>-1){
									if(jobLevel>=8){
										item.Value=1
									}else{
										item.Value = this.getCondtion(this.relationList, 8, 1);
									}
								}
								else{
									if(jobLevel>=7){
										item.Value=1
									}else{
										item.Value = this.getCondtion(this.relationList, 7, 1);
									}
								}
								
							}
							if (title.indexOf("商业地产") > -1) {
								if(jobLevel>=7){
									item.Value=2
								}else{
									item.Value = this.getCondtion(this.relationList, 7, 2);
								}
							}
							if (title.indexOf("房友圈") > -1) {
								if(jobLevel>=8){
									item.Value=3
								}else{
									item.Value = 3.7;
								}
							}
							if (title.indexOf("藤云") > -1) {
								if(jobLevel>=8){
									item.Value=3
								}else{
									item.Value = this.getCondtion(this.relationList, 8, 3);
								}
							}
							if (title.indexOf("二级市场营运中心") > -1 || title.indexOf("代理") > -1) {
								if(jobLevel>=8){
									item.Value=4
								}else{
									item.Value = this.getCondtion(this.relationList, 8, 4);
								}
								
							}
						}
						if (item.Property.Title[0].Text == "追佣类型") {
							//不匹配
							if (title.indexOf("商业地产")) {
								item.IsShow = false;
							} else {
								item.Property.Require = 1;
							}
						}
						if (item.Property.Title[0].Text == "暂缓日期") {
							item.IsShow = false
						}
						if (item.Property.Title[0].Text == "撤销日期") {

							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "发票编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name) {
				if (name == "是否存在已开发票未回款情况") {
					var IsShow=false;
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "是"&&item.Key==val;
						})[0];
					var numControl = controls.filter(item => item.Property.Title[0].Text == "发票编号")[0]
					if (option != null) {
						IsShow=true;
					} 
					numControl.IsShow = IsShow;
					numControl.Property.Require = IsShow?1:0;
				}
				if (name == "选择类型") {
					var isStop = false;
					var isCancel = false;
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var optionType = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Key == val;
						})[0];
					var stopControl = controls.filter(item => item.Property.Title[0].Text == "暂缓日期")[0];
					var cancelControl = controls.filter(item => item.Property.Title[0].Text == "撤销日期")[0];
					if (optionType.Value[0].Text == "暂缓") {
						cancelControl.Value =null;
						isStop = true;
					}
					if (optionType.Value[0].Text == "撤销") {
						let date = new Date();
						stopControl.Value =null;
						cancelControl.Value = formatDate(date, "yyyy-MM-dd");
						isCancel = true;
					}
					cancelControl.IsShow = isCancel;
					stopControl.IsShow = isStop;

					cancelControl.Property.Require = isCancel ? 1 : 0;
					stopControl.Property.Require = isStop ? 1 : 0;
				}
				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "部门"})[0]
				info.SummaryInfo.push({"Text":"申请部门："+control1.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "选择类型"})[0]
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "项目名称"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				for (var i = 0; i < control3.Config.Selector.Options.length; i++) {
					var data = control3.Config.Selector.Options[i];
					if(data.Key ==control3.Value){
						NameOfData = data.Value[0].Text;
					}
				}
				info.SummaryInfo.push({"Text":"选择类型："+ NameOfData ,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"项目名称："+control4.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList
				
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.formLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});
			}
		},
		watch: {
			relationList: 'getTemplate'
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
